import React, { useRef } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import { useStore } from '../../../store';
import { IInputValue } from '../../../domains/common.domain';
import useRegisterErrorField from '../hooks/register-error-field-hook';
import { useTranslation } from 'react-i18next';
import { getLanguageCode } from '../../../translations/i18n';
import { DateType } from '../../../domains/onboarding-information.domain';

interface IDateInputProps {
  date: IInputValue<Date | null>;
  label: string;
  placeholder: string;
  error: string;
  onUpdate: (date: Date | null) => void;
  optional?: boolean;
  type?: DateType;
}

const DateInput = observer((props: IDateInputProps) => {
  const { t } = useTranslation('');
  const { date, label, placeholder, error, onUpdate, optional = false, type = 'install' } = props;
  const { signUpStore, tenantStore, quoteStore } = useStore();
  const { config } = tenantStore;
  const fieldRef = useRef<HTMLDivElement | null>(null);
  useRegisterErrorField(fieldRef, date.errorType);
  const startDate = new Date();
  const targetStartDays =
    type === 'install' && quoteStore.isCustomerInService && !!config.targetAddonStartDays
      ? config.targetAddonStartDays
      : config.targetStartDays;
  startDate.setDate(startDate.getDate() + targetStartDays);
  const maxDate = new Date();
  maxDate.setFullYear(maxDate.getFullYear() + 5);

  return (
    <div className={'container-input'} ref={fieldRef}>
      <label>
        {label} {optional && <span className="label-optional">{t('COMMON.OPTIONAL')}</span>}
      </label>
      <div className={'controls'}>
        <DatePicker
          selected={date?.value}
          className={classNames(date?.errorType && signUpStore.showErrors && 'error', 'calendar')}
          dateFormat={config.dateFormat}
          minDate={startDate}
          startDate={startDate}
          placeholderText={placeholder}
          onChange={date => onUpdate(date)}
          locale={getLanguageCode()}
          maxDate={maxDate}
        />
        {date?.errorType && signUpStore.showErrors && <label className={'error'}>{error}</label>}
      </div>
    </div>
  );
});

export default DateInput;
